<template>
    <div class="config">
        <div class="header">
            <h1> {{ getString('configuracoes') }}</h1>
        </div>
        <form @submit.prevent="setConfigs" enctype="multipart/form-data" class="config-container"
            :class="{ 'keyboard-open': visible }">

            <div class="config-group"
                :class="{ 'open': exibeEndereco, 'config-group-disabled': !hasPermission('configs') }"
                v-if="enableAllConfigs">
                <h2 @click="exibeEndereco = !exibeEndereco"><span class="icon">‹</span><span class="title">{{
                    getString('enderecos') }}</span></h2>
                <div class="cofig-item-container">
                    <div class="cofig-item"
                        v-if="false && config.availableInterfaces && config.availableInterfaces.length">
                        <div class="label-container">
                            <label for="urlOdhenInterface" v-text="getString('odhen_interface')"></label>
                        </div>
                        <select class="modelosPreDefinidos" name="urlOdhenInterface" id="urlOdhenInterface"
                            v-model="config.urlOdhenInterface" @change="updateInterfaceURI">
                            <option v-for="(interfaces, key) in config.availableInterfaces" :key="key"
                                :value="interfaces.path" v-text="interfaces.version"></option>
                        </select>
                    </div>
                    <!--
                    <div class="cofig-item">
                        <div class="label-container">
                            <label for="urlIMGOdhenInterface" v-text="'Url das imagens cacheadas na Odhen Interface DNS'"></label>
                        </div>
                        <input type="url" id="urlIMGOdhenInterface" placeholder="http://..." v-model="config.urlIMGOdhenInterface">
                    </div> -->
                    <div class="cofig-item" v-if="!isAndroid()">
                        <div class="label-container">
                            <label for="urlPerifericos" v-text="getString('perifericos_DNS')"></label>
                        </div>
                        <input type="url" id="urlPerifericos" placeholder="http://..." @focus="show" :layout="layout"
                            autocomplete="off" v-model="config.urlPerifericos">
                    </div>
                    <div class="cofig-item" v-if="!isAndroid()">
                        <div class="label-container">
                            <label for="balancaport" v-text="getString('porta_balanca')"></label>
                        </div>
                        <input type="text" id="balancaport" @focus="show" :layout="layout" autocomplete="off"
                            placeholder="http://..." v-model="config.balancaport">
                    </div>
                    <div class="cofig-item" v-if="false">
                        <div class="label-container">
                            <label for="sitefAddress" v-text="getString('endereco_sitef')"></label>
                        </div>
                        <input type="text" id="sitefAddress" placeholder="http://..." v-model="config.sitefAddress"
                            @focus="show">
                    </div>
                    <div class="cofig-item" v-if="config.useFaceRecognition">
                        <div class="label-container">
                            <label for="faceRecognitionApi" v-text="getString('face_recognition_api')"></label>
                        </div>
                        <input type="text" id="faceRecognitionApi" placeholder="https://..." v-model="config.faceRecognitionApi"
                            @focus="show">
                    </div>
                </div>
            </div>

            <div class="config-group" v-if="enableAllConfigs"
                :class="{ 'open': exibeCores, 'config-group-disabled': !hasPermission('colors') }">
                <h2 @click="exibeCores = !exibeCores"><span class="icon">‹</span><span class="title">{{
                    getString('cores') }}</span></h2>
                <div class="cofig-item-container">
                    <div class="cofig-item">
                        <div class="label-container">
                            <label for="primary_color" v-text="getString('primary_color')"></label>
                        </div>
                        <input type="color" id="primary_color" name="primary_color" v-model="config.primary_color">
                    </div>
                    <div class="cofig-item">
                        <div class="label-container">
                            <label for="primary_light" v-text="getString('primary_light')"></label>
                        </div>
                        <input type="color" id="primary_light" name="primary_light" v-model="config.primary_light">
                    </div>
                    <div class="cofig-item">
                        <div class="label-container">
                            <label for="primary_dark" v-text="getString('primary_dark')"></label>
                        </div>
                        <input type="color" id="primary_dark" name="primary_dark" v-model="config.primary_dark">
                    </div>
                    <div class="cofig-item">
                        <div class="label-container">
                            <label for="header_color" v-text="getString('header_color')"></label>
                        </div>
                        <input type="color" id="header_color" name="header_color" v-model="config.header_color">
                    </div>
                    <div class="cofig-item">
                        <div class="label-container">
                            <label for="header_color" v-text="getString('categorie_color')"></label>
                        </div>
                        <input type="color" id="categorie_color" name="categorie_color"
                            v-model="config.categorie_color">
                    </div>
                    <div class="cofig-item">
                        <div class="label-container">
                            <label for="header_color" v-text="getString('categorie_font_color')"></label>
                        </div>
                        <input type="color" id="categorie_font_color" name="categorie_font_color"
                            v-model="config.categorie_font_color">
                    </div>
                    <div class="cofig-item">
                        <div class="label-container">
                            <label for="cart_color" v-text="getString('cart_color')"></label>
                        </div>
                        <input type="color" id="cart_color" name="cart_color" v-model="config.cart_color">
                    </div>
                    <div class="cofig-item">
                        <div class="label-container">
                            <label for="cart_font_color" v-text="getString('cart_font_color')"></label>
                        </div>
                        <input type="color" id="cart_font_color" name="cart_font_color"
                            v-model="config.cart_font_color">
                    </div>
                    <div class="cofig-item">
                        <div class="label-container">
                            <label for="price_font_color" v-text="getString('price_font_color')"></label>
                        </div>
                        <input type="color" id="price_font_color" name="price_font_color"
                            v-model="config.price_font_color">
                    </div>

                    <div class="cofig-item">
                        <span>{{ getString('preco_em_negrito') }}</span>
                        <input id="boldPrice" class="troca opcaoComSwitch" type="checkbox" v-model="config.boldPrice" />
                        <label for="boldPrice"></label>
                    </div>
                </div>
            </div>

            <div class="config-group" v-if="enableAllConfigs"
                :class="{ 'open': exibeIdiomas, 'config-group-disabled': !hasPermission('changeLanguage') }">
                <h2 @click="exibeIdiomas = !exibeIdiomas"><span class="icon">‹</span><span class="title">{{
                    getString('idiomas') }}</span></h2>

                <div class="cofig-item-container">

                    <h3>{{ getString('idioma_principal') }}</h3>

                    <div class="config-radios">
                        <div v-for="(language, key) in languages" :key="key" class="option">
                            <div class="container-input">
                                <input class="styled-input" :id="key" type="checkbox" :value="language"
                                    v-model="config.mainLanguage" @change="changeMainLanguage(language, $event)">
                                <label class="checkmark radio" :for="key"></label>
                            </div>
                            <label :for="key">
                                <span class="language-label" v-text="language.name"></span>
                            </label>
                        </div>
                    </div>

                    <h3>{{ getString('idiomas_adicionais') }}</h3>

                    <div class="cofig-item-container checkbox">
                        <div class="cofig-item">
                            <div class="container-input">
                                <input class="styled-input" type="checkbox" name="pt-br" id="pt-br" value="pt-br"
                                    v-model="config.idiomaAdic_pt_br" @click="checkSameLanguage($event)">
                                <span class="checkmark"></span>
                            </div>
                            <div class="label label-mod-entrega">
                                <label for="pt-br">{{ getString('portugues') }}</label>
                            </div>
                        </div>

                        <div class="cofig-item">
                            <div class="container-input">
                                <input class="styled-input" type="checkbox" name="en" id="en" value="en"
                                    v-model="config.idiomaAdic_en" @click="checkSameLanguage($event)">
                                <span class="checkmark"></span>
                            </div>
                            <div class="label label-mod-entrega">
                                <label for="en">{{ getString('ingles') }}</label>
                            </div>
                        </div>

                        <div class="cofig-item">
                            <div class="container-input">
                                <input class="styled-input" type="checkbox" name="es" id="es" value="es"
                                    v-model="config.idiomaAdic_es" @click="checkSameLanguage($event)">
                                <span class="checkmark"></span>
                            </div>
                            <div class="label label-mod-entrega-last">
                                <label for="es">{{ getString('espanhol') }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="config-group" :class="{
                'open': exibeConsumidor,
                'config-group-disabled': (!hasPermission('configs') && !hasPermission('cashierClosing') && !hasPermission('cancelSale') && !hasPermission('blockProduct'))
            }">
                <h2 @click="exibeConsumidor = !exibeConsumidor; checkConectionStatus()"><span class="icon">‹</span><span
                        class="title">{{ getString('consumidor') }}</span></h2>
                <div class="cofig-item-container">
                    <template v-if="isOracle">
                        <div class="cofig-item" v-if="false">
                            <div class="label-container">
                                <label for="consumidorTipo" v-text="getString('tipo_consumidor')"></label>
                            </div>
                            <input type="text" id="consumidorTipo" v-model="config.consumidorTipo" @focus="show">
                        </div>

                        <div class="cofig-item" v-if="false">
                            <div class="label-container">
                                <label for="lojaCodigo" v-text="getString('codigo_loja')"></label>
                            </div>
                            <input type="text" id="lojaCodigo" v-model="config.lojaCodigo"
                                @change="config.curtaa = null" @focus="show">
                        </div>

                        <div class="cofig-item">
                            <div class="label-container">
                                <label for="filialCodigo" v-text="getString('codigo_filial')"></label>
                            </div>
                            <div id="filialCodigo" class="subsidiary-Input" @click="showSubisdiaryList()"
                                v-text="config.curSubisdiary ? config.curSubisdiary.subsidiaryCode + ' ' + config.curSubisdiary.subsidiaryName : 'Selecione a Filial'">
                            </div>
                        </div>
                    </template>
                    <template v-if="hasPermission('configs')">
                        <div class="cofig-item" @click="isOracle ? showPosList() : checkConectionStatus(true)">
                            <div class="label-container">
                                <label for="taapicker" v-text="getString('dispositivo')"></label>
                            </div>
                            <select class="modelosPreDefinidos" name="taapicker" id="taapicker" v-model="config.curtaa"
                                v-if="!isOracle" @change="confirmImportPosConfig()">
                                <option value="null" selected></option>
                                <option :value="taa" v-for="(taa, key) in config.taas" :key="key"
                                    :selected="taa.posCode === config.caixaCodigo" v-text="taa.posName"></option>
                            </select>
                            <div class="subsidiary-Input" v-else
                                v-text="config.nomeDoDispositivo ? config.caixaCodigo + ' ' + config.nomeDoDispositivo : 'Selecione o Caixa'">
                            </div>
                        </div>

                        <div class="cofig-item">
                            <div class="label-container">
                                <label for="comprimentoNSU" v-text="getString('digitos_NSU')"></label>
                            </div>
                            <input type="number" id="comprimentoNSU" v-model="config.comprimentoNSU" @focus="show">
                        </div>

                        <div class="cofig-item">
                            <span>{{ getString('fechamento_automatico') }}</span>
                            <input id="shouldAutoClose" class="troca opcaoComSwitch" type="checkbox"
                                v-model="config.shouldAutoClose" />
                            <label for="shouldAutoClose"></label>
                        </div>
                        <div class="cofig-item">
                            <span>{{ getString('exibe_saldo_consumidor_sem_controle') }}</span>
                            <input id="exibeSaldoConsumidorSemControle" class="troca opcaoComSwitch" type="checkbox"
                                v-model="config.exibeSaldoConsumidorSemControle" />
                            <label for="exibeSaldoConsumidorSemControle"></label>
                        </div>
                    </template>

                    <div v-if="config.curtaa && hasPermission('cashierClosing')" class="cofig-item"
                        style="display: block">
                        <div class="test-printer-container">
                            <div class="test-printer-box" @click="relatorioFechamentoDodia">
                                <img :src="print_white" alt="">
                                <span>{{ getString('emitir_fechamento_dia') }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="hasPermission('cancelSale') && !isNfseMode()" class="cofig-item" style="display: block">
                        <div class="test-printer-container">
                            <div class="test-printer-box" @click="cancelTef">
                                <img :src="money_white" alt="">
                                <span>{{ getString('cancelamento_TEF') }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="hasPermission('cancelSale') && !isNfseMode()" class="cofig-item" style="display: block">
                        <div class="test-printer-container">
                            <div class="test-printer-box" @click="openReprintModal">
                                <img :src="money_white" alt="">
                                <span>{{ getString('reimpressao_cupom_fiscal') }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="config.curtaa && hasPermission('blockProduct')" class="cofig-item" style="display: block">
                        <div class="test-printer-container" @click="hide">
                            <div class="test-printer-box" @click="toggleProdBolck">
                                <img class="x-image" :src="close_white" alt="">
                                <span>{{ getString('bloquear_desbloquear_produtos') }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="config.curtaa && hasPermission('blockProduct')" class="cofig-item" style="display: block">
                        <div class="test-printer-container" @click="hide">
                            <div class="test-printer-box test-printer-box--tax" @click="openTaxValidation">
                                <img class="x-image" :src="close_white" alt="">
                                <span>{{ getString('validacao_fiscal_produtos') }}</span>
                                <span v-if="taxValidationPendingCount > 0" class="tax-pending-badge">
                                    {{ taxValidationPendingCount }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div v-if="hasPermission('cancelSale') && !isNfseMode() && !isTransire()" class="cofig-item" style="display: block">
                        <div class="test-printer-container" @click="hide">
                            <div class="test-printer-box" @click="iniciaFuncoesAdministrativas">
                                <img :src="money_white" alt="">
                                <span>{{ getString('funcoes_sitef') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="cofig-item inline-item" v-if="isTransire()">
                        <div class="label-container">
                            <label for="transireToken" v-text="getString('token_transire')"></label>
                        </div>
                        <input id="transireToken" placeholder="" maxlength="4" type="password" inputmode="numeric" v-model="config.transireToken" @focus="show">
                        <div class="test-printer-container">
                            <div class="test-printer-box" @click="registerTransireToken">
                                <span>{{ getString('Registrar_token') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="cofig-item">
                        <div class="label-container">
                            <label for="clarityProjectId" v-text="getString('clarity_project_id')"></label>
                        </div>
                        <input type="text" id="clarityProjectId" placeholder="" v-model="config.clarityProjectId"
                            @focus="show">
                    </div>
                </div>
            </div>
            <div class="config-group" :class="{ 'open': isCameraConfigMenuOpen, 'config-group-disabled': false }"
                v-if="!isAndroid() && config.useFaceRecognition">
                <h2 @click="isCameraConfigMenuOpen = !isCameraConfigMenuOpen"><span class="icon">‹</span>
                    <span class="title">{{ getString('Configurações de Câmeras') }}</span>
                </h2>
                <div class="cofig-item-container">
                    <div class="cofig-item">
                        <div class="label-container">
                            <label for="faceCamera" v-text="getString('Câmera para Face:')"></label>
                        </div>
                        <select class="modelosPreDefinidos" name="faceCamera" id="faceCamera"
                            v-model="selectedFaceCamera">
                            <option v-for="camera in cameras" :key="camera.deviceId" :value="camera.deviceId">
                                {{ camera.label || `Câmera ${camera.deviceId}` }}
                            </option>
                        </select>
                        <!--<div class="label-container">
                            <label for="faceCamera" v-text="getString('Câmera para Produtos:')"></label>
                        </div>
                        <select class="modelosPreDefinidos" name="productCamera" id="productCamera" v-model="selectedProductCamera">
                            <option v-for="camera in cameras" :key="camera.deviceId" :value="camera.deviceId">
                                {{ camera.label || `Câmera ${camera.deviceId}` }}
                            </option>
                        </select> -->
                    </div>
                    <div class="apply-btn-container">
                        <div class="apply-btn" @click="applyCameraSettings">Aplicar Configurações</div>
                    </div>
                    <div class="video">
                        <faceVideoComp :portrait="true" v-if="isCameraConfigMenuOpen"></faceVideoComp>
                    </div>
                </div>
            </div>
            <!-- <div class="config-group" v-if="isAndroid() || (!isAndroid() && selectedFaceCamera)" :class="{ 'open': isFaceRegisterOpen, 'config-group-disabled': false }"> -->
            <div class="config-group" v-if="false" :class="{ 'open': isFaceRegisterOpen, 'config-group-disabled': false }">
                <h2 @click="isFaceRegisterOpen = !isFaceRegisterOpen">
                    <span class="icon">‹</span>
                    <span class="title">{{ getString('Registro de rostos') }}</span>
                </h2>
                <div class="cofig-item-container">
                    <div class="apply-btn-container">
                        <div class="apply-btn" @click="openFaceRegistrationModal()">Registro de rosto</div>
                    </div>
                </div>
            </div>

            <div class="config-group" v-if="enableAllConfigs"
                :class="{ 'open': exibeModeEntrega, 'config-group-disabled': !hasPermission('changeMode') }">
                <h2 @click="exibeModeEntrega = !exibeModeEntrega"><span class="icon">‹</span><span class="title">{{
                    getString('modalidade_entrega') }}</span></h2>
                <div class="cofig-item-container checkbox">

                    <div class="cofig-item">
                        <div class="container-input">
                            <input class="styled-input" type="checkbox" name="drive" id="drive" value="drive"
                                v-model="config.modeEntregaDrive" @click="() => config.modeEntrega = []">
                            <span class="checkmark"></span>
                        </div>
                        <div class="label label-mod-entrega">
                            <label for="drive">{{ getString('drive_throught') }}</label>
                        </div>
                    </div>

                    <div class="cofig-item">
                        <div class="container-input">
                            <input class="styled-input" type="checkbox" name="comer" id="comer" value="comer"
                                v-model="config.modeEntrega" @click="config.modeEntregaDrive = []">
                            <span class="checkmark"></span>
                        </div>
                        <div class="label label-mod-entrega">
                            <label for="comer">{{ getString('comer_aqui') }}</label>
                        </div>
                    </div>

                    <div class="cofig-item">
                        <div class="container-input">
                            <input class="styled-input" type="checkbox" name="levar" id="levar" value="levar"
                                v-model="config.modeEntrega" @click="config.modeEntregaDrive = []">
                            <span class="checkmark"></span>
                        </div>
                        <div class="label label-mod-entrega-last">
                            <label for="levar">{{ getString('levar') }}</label>
                        </div>
                    </div>

                </div>
            </div>

            <div class="config-group"
                :class="{ 'open': exibeImpressora, 'config-group-disabled': !hasPermission('printer') }">
                <h2 @click="exibeImpressora = !exibeImpressora"><span class="icon">‹</span><span class="title">{{
                    getString('parametrizacao_impressora') }}</span></h2>
                <div class="cofig-item-container">

                    <div v-if="isTectoy()" class="cofig-item">
                        <div class="label-container">
                            <label for="modeloImpressora" v-text="getString('modelo')"></label>
                        </div>
                        <select class="modelosPreDefinidos" name="modeloImpressora" id="modeloImpressora"
                            v-model="config.modeloImpressora">
                            <option value="28" selected>{{ getString('tectoy_impressora_pequena') }}</option>
                            <option value="29">{{ getString('tectoy_impressora_grande') }}</option>
                        </select>
                    </div>

                    <template v-else-if="!isAndroid() || (isAndroid() && !isTectoy() && !isGertecSk210())">
                        <div class="cofig-item">
                            <div class="label-container">
                                <label for="modeloImpressora" v-text="getString('modelo')"></label>
                            </div>
                            <!-- <select class="modelosPreDefinidos" name="modeloImpressora" id="modeloImpressora" v-model="config.modeloImpressora" >
                                <option value="null" selected></option>
                                <option value="1">{{ getString('bematech_Mp_20') }}</option>
                                <option value="2">{{ getString('epson_tm_T88IIP') }}</option>
                                <option value="3">{{ getString('bematech_Mp_2100') }}</option>
                                <option value="4">{{ getString('bematech_Mp_4000') }}</option>
                                <option value="5">{{ getString('sewoo_chile') }}</option>
                                <option value="6">{{ getString('IBM_4610_colombia') }}</option>
                                <option value="7">{{ getString('bematech_MP_100_peru') }}</option>
                                <option value="8">{{ getString('daruma_DR600') }}</option>
                                <option value="9">{{ getString('epson_TM_U22A') }}</option>
                                <option value="10">{{ getString('daruma_DR700') }}</option>
                                <option value="11">{{ getString('epson_M244A') }}</option>
                                <option value="12">{{ getString('zebra_Tlp_2844') }}</option>
                                <option value="13">{{ getString('bematech_MP_4200') }}</option>
                                <option value="14">{{ getString('epson_TM_T88V') }}</option>
                                <option value="16">{{ getString('epson_TM_T20') }}</option>
                                <option value="17">{{ getString('sweda_SI_300S') }}</option>
                                <option value="18">{{ getString('elgin_I9') }}</option>
                                <option value="19">{{ getString('epson_TM_T88IV_ethernet') }}</option>
                                <option value="20">{{ getString('elgin_kiosk_BKT681') }}</option>
                                <option value="21">{{ getString('bematech_MP_4200_compartilhada') }}</option>
                                <option value="23">{{ getString('custom_TG2480H') }}</option>
                                <option value="25">{{ getString('gpos700') }}</option>
                                <option value="26">{{ getString('poynt') }}</option>
                                <option value="55">{{ getString('Menno MM-300H') }}</option>
                                <option value="57">{{ getString('TC-35') }}</option>
                            </select> -->
                            <input type="text" id="portaImpressora" disabled
                                :value="config.modeloImpressora + ' - ' + config.nomeImpressora">
                        </div>
                        <div class="cofig-item">
                            <div class="label-container">
                                <label for="codigoTerminalTEF" v-text="getString('porta_impressora')"></label>
                            </div>
                            <input type="text" id="portaImpressora" disabled v-model="config.portaImpressora">
                        </div>
                    </template>

                    <div class="cofig-item" style="display: block" @click="testPrinter">
                        <div class="test-printer-container">
                            <div class="test-printer-box">
                                <img :src="print_white" alt="">
                                <span>{{ getString('testar_impressora') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="config-group" v-if="config.modobalanca && !isAndroid()"
                :class="{ 'open': exibeModeBalanca, 'config-group-disabled': !hasPermission('changeMode') }">
                <h2 @click="exibeModeBalanca = !exibeModeBalanca"><span class="icon">‹</span><span class="title">{{
                    getString('modo_balanca') }}</span></h2>
                <div class="cofig-item-container">
                    <div class="cofig-item" style="display: block" @click="showModalBalanca = true">
                        <div class="test-printer-container">
                            <div class="test-printer-box">
                                <img :src="balanca" alt="" style="filter: invert(100%);">
                                <span>{{ getString('Adicionar/Remover produtos pesaveis') }}</span>
                            </div>
                        </div>
                    </div>
                    <BalancaModeConfig v-if="showModalBalanca" :isBalanca="config.modobalanca" :config="config"
                        @saveBalancaMode="saveBalancaMode"></BalancaModeConfig>
                </div>
            </div>

            <div class="config-group" v-if="enableAllConfigs"
                :class="{ 'open': exibelayoutConfig, 'config-group-disabled': !hasPermission('layout') }">
                <h2 @click="exibelayoutConfig = !exibelayoutConfig"><span class="icon">‹</span><span class="title">{{
                    getString('Layout') }}</span></h2>
                <div class="cofig-item-container">
                    <div class="cofig-item">
                        <span>{{ getString('utiliza_layout_alternativo') }}</span>
                        <input id="utiliza_layout_gom" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.utiliza_layout_gom"
                            @change="config.slimMode = false; config.hideGroupOnMax = false; config.useAlternativeLayout = true; config.itemsList = false" />
                        <label for="utiliza_layout_gom"></label>
                    </div>
                    <div class="cofig-item" v-if="!isGertecSk210() && !config.utiliza_layout_gom">
                        <span>{{ getString('habilita_modo_slim') }}</span>
                        <input id="opacoEnableSlimMode" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.slimMode" @change="disableGomLayout(config.slimMode)" />
                        <label for="opacoEnableSlimMode"></label>
                    </div>
                    <div v-if="!isAndroid()" class="cofig-item">
                        <span>{{ getString('modo_balanca') }}</span>
                        <input id="modobalanca" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.modobalanca" @change="config.modotap = false" />
                        <label for="modobalanca"></label>
                    </div>
                    <div class="cofig-item">
                        <span>{{ getString('habilita_modo_edicao') }}</span>
                        <input id="opacoEnableEditMode" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.isEditMode" />
                        <label for="opacoEnableEditMode"></label>
                    </div>
                    <div class="cofig-item">
                        <span>{{ getString('exibe_botao_continuar_comprando') }}</span>
                        <input id="exibeContinuarComprando" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.exibeContinuarComprando" />
                        <label for="exibeContinuarComprando"></label>
                    </div>
                    <div class="cofig-item" v-if="!config.utiliza_layout_gom">
                        <span>{{ getString('exibe_itens_em_lista') }}</span>
                        <input id="opcaoListItems" class="troca opcaoComSwitch" type="checkbox"
                            @change="disableGomLayout(config.itemsList)" v-model="config.itemsList" />
                        <label for="opcaoListItems"></label>
                    </div>
                    <div class="cofig-item" v-if="!isGertecSk210() && !config.utiliza_layout_gom && false">
                        <span>{{ getString('minimiza_grupo_quantidade_maxima') }}</span>
                        <input id="opcaoHideGroup" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.hideGroupOnMax" @change="disableGomLayout(config.hideGroupOnMax)" />
                        <label for="opcaoHideGroup"></label>
                    </div>
                    <div class="cofig-item">
                        <span>{{ getString('avanca_grupo_quantidade_maxima') }}</span>
                        <input id="opcaoJumpGroup" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.enableJumpGroup" />
                        <label for="opcaoJumpGroup"></label>
                    </div>
                    <div class="cofig-item">
                        <span>{{ getString('sinaliza_desconto') }}</span>
                        <input id="signalsDiscount" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.signalsDiscount" />
                        <label for="signalsDiscount"></label>
                    </div>
                    <div class="cofig-item">
                        <span>{{ getString('utiliza_login_inicio') }}</span>
                        <input id="opacoEnableLoginInicio" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.enableLoginInicio" />
                        <label for="opacoEnableLoginInicio"></label>
                    </div>
                </div>
            </div>

            <div class="config-group"
                :class="{ 'open': exibeGeneralConfig, 'config-group-disabled': !hasPermission('generalConfigs') }">
                <h2 @click="exibeGeneralConfig = !exibeGeneralConfig"><span class="icon">‹</span><span class="title">{{
                    getString('gerais') }}</span></h2>
                <div class="cofig-item-container">
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('imprimir_pedidos_em_fichas') }}</span>
                        <input id="opacoPrintTokens" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.impFichas" />
                        <label for="opacoPrintTokens"></label>
                    </div>
                    <div class="cofig-item"> <!-- TODO: utilizar parametro do retail inicialmente estará desabilitado-->
                        <span>{{ getString('utiliza_reconhecimento_facial') }}</span>
                        <input id="opacoUseFaceRecognition" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.useFaceRecognition" />
                        <label for="opacoUseFaceRecognition"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('habilita_leitura_cod') }}</span>
                        <input id="opacoEnableProdBarCodeRead" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.enableProdBarCodeRead" />
                        <label for="opacoEnableProdBarCodeRead"></label>
                    </div>
                    <div class="cofig-item" v-if="!isGertecSk210() && enableAllConfigs">
                        <span>{{ getString('habilita_acessibilidade') }}</span>
                        <input id="opacoEnableAcessibilidade" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.acessibilidade" />
                        <label for="opacoEnableAcessibilidade"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('habilita_agruparnaimpressao') }}</span>
                        <input id="opacoEnableAgruparnaImpressao" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.agruparnaimpressao" />
                        <label for="opacoEnableAgruparnaImpressao"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('exibir_produtos_sem_foto') }}</span>
                        <input id="opcaSemFoto" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.produtoSemfoto" />
                        <label for="opcaSemFoto"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('exibir_a_partir_de') }}</span>
                        <input id="exibApartir" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.exibApartir" />
                        <label for="exibApartir"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('remover_opcoes_impressao_envio_cupom_fiscal') }}</span>
                        <input id="removeConfirmImpressaoCupom" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.removeConfirmImpressaoCupom" />
                        <label for="removeConfirmImpressaoCupom"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('cardapio_deve_expirar') }}</span>
                        <input id="cardapioExpira" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.cardapioExpira" />
                        <label for="cardapioExpira"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('utiliza_pager') }}</span>
                        <input id="opcaoPager" class="troca opcaoComSwitch" type="checkbox" v-model="config.usePager" />
                        <label for="opcaoPager"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs && config.usePager">
                        <span>{{ getString('utiliza_leitor_barras') }}</span>
                        <input id="useBarcode" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.useBarcode" />
                        <label for="useBarcode"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('altera_quantidade_adicionais') }}</span>
                        <input id="opcaoAllowMultipleAdd" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.allowMultipleAdd" />
                        <label for="opcaoAllowMultipleAdd"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('imprime_espelho_pedido') }}</span>
                        <input id="opcaoImprimeEspelho" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.imprimeEspelho" />
                        <label for="opcaoImprimeEspelho"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('habilita_subgrupos') }}</span>
                        <input id="opcaoEnableSubgroups" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.enableSubgroups" />
                        <label for="opcaoEnableSubgroups"></label>
                    </div>
                    <div class="cofig-item" v-if="false">
                        <span>{{ getString('habilita_observacao_digitada') }}</span>
                        <input id="opcaoObsDigitada" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.permiteObsDigitada" />
                        <label for="opcaoObsDigitada"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('taxa_servico_fixa') }}</span>
                        <input id="fixedServiceTax" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.fixedServiceTax" />
                        <label for="fixedServiceTax"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('taxa_servico_automatica') }}</span>
                        <input id="automaticServiceTax" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.automaticServiceTax" />
                        <label for="automaticServiceTax"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('remove_taxa_servico') }}</span>
                        <input id="changeServiceTax" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.removTXServTap" />
                        <label for="changeServiceTax"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('diferenca_preco_minimo') }}</span>
                        <input id="showMinPriceDifference" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.showMinPriceDifference" />
                        <label for="showMinPriceDifference"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <div class="label-container">
                            <label for="timeOut" v-text="getString('timeOut_inatividade')"></label>
                        </div>
                        <input type="number" min="10" id="timeOut" @focus="show" :layout="layout" autocomplete="off"
                            v-model="config.timeOut">
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <div class="label-container">
                            <label for="timeOutInModal" v-text="getString('timeOutInModal_inatividade')"></label>
                        </div>
                        <input type="number" min="5" id="timeOutInModal" @focus="show" :layout="layout"
                            autocomplete="off" v-model="config.timeOutInModal">
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('pagamentos_homologacao') }}</span>
                        <input id="homologPay" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.homologPay" />
                        <label for="homologPay"></label>
                    </div>
                    <div class="cofig-item" v-if="isGertecSk210()">
                        <span>{{ getString('ignore_qrCode') }}</span>
                        <input id="ignoreQrCode" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.ignoreQrCode" />
                        <label for="ignoreQrCode"></label>
                    </div>
                    <div class="cofig-item" v-if="true">
                        <span>{{ getString('remove_produto_sugestao_automatico') }}</span>
                        <input id="removeProdutoSugestaoAutomatico" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.removeProdutoSugestaoAutomatico" />
                        <label for="removeProdutoSugestaoAutomatico"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('adicionar_produto') }}</span>
                        <input id="addprodTAP" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.addprodTAP" />
                        <label for="addprodTAP"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('remove_imprimir_cupom') }}</span>
                        <input id="hidePrintButton" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.hidePrintButton" />
                        <label for="hidePrintButton"></label>
                    </div>
                    <div class="cofig-item" v-if="enableAllConfigs">
                        <span>{{ getString('sem_imprimir_comprovante_e_pedido') }}</span>
                        <input id="allowNotPrint" class="troca opcaoComSwitch" type="checkbox"
                            v-model="config.allowNotPrint" />
                        <label for="allowNotPrint"></label>
                    </div>
                </div>
            </div>

            <div class="config-group"
                :class="{ 'open': imageManage, 'config-group-disabled': !hasPermission('images') }">
                <h2 @click="imageManage = !imageManage"><span class="icon">‹</span><span class="title">{{
                    getString('imagens_customizaveis') }}</span></h2>
                <div class="cofig-item-container">
                    <div class="cofig-item" v-for="(imageReq, key) in imageList" :key="key">
                        <div class="label-container">
                            <label :for="imageReq.id" style="display: block" v-text="imageReq.label"></label>
                            <label :for="imageReq.id" style="display: block" v-text="imageReq.size"></label>
                        </div>
                        <div class="img-container">
                            <template
                                v-if="storedImages[imageReq.id] && storedImages[imageReq.id].image && isVideo(storedImages[imageReq.id].image)">
                                <video :src="storedImages[imageReq.id].image"></video>
                            </template>
                            <template v-else>
                                <img
                                    :src="storedImages[imageReq.id] && storedImages[imageReq.id].image || defaultImage">
                            </template>
                            <input type="file" :id="imageReq.id" accept="video/mp4,image/png,image/jpeg,image/gif"
                                :ref="imageReq.id" @change="setImage($event, imageReq.id)">
                            <span class="clear-input" v-text="'X'"
                                v-if="config && (config.images[imageReq.id] || storedImages[imageReq.id])"
                                @click="clearInput(imageReq.id)"></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="config-group"
                :class="{ 'open': configManage, 'config-group-disabled': (!hasPermission('importConfigs') && !hasPermission('exportConfigs')) }"
                v-if="!isOracle && enableAllConfigs">
                <h2 @click="configManage = !configManage"><span class="icon">‹</span><span class="title">{{
                    getString('importar_exportar_configuracoes') }}</span></h2>
                <div class="cofig-item-container">
                    <div v-if="hasPermission('exportConfigs')" class="cofig-item" style="display: block"
                        @click="confirmExportConfig()">
                        <div class="test-printer-container">
                            <div class="test-printer-box">
                                <!--<img :src="print_white" alt=""> -->
                                <span>{{ getString('definir_configuracoes_como_padrao') }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="hasPermission('importConfigs')" class="cofig-item" style="display: block"
                        @click="confirmImportConfig()">
                        <div class="test-printer-container">
                            <div class="test-printer-box">
                                <!--<img :src="print_white" alt=""> -->
                                <span>{{ getString('importar_configuracoes_servidor') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <DefaultButton class="button-default" :text="getString('configurar')"></DefaultButton>
        </form>
        <div class="overlay" v-if="showCancelTefModal || prodBlock || confirmConfig || showSelectModal || showOverlay"
            @click="closeModal"></div>
        <CancelTefModal v-if="showCancelTefModal" @closeModal="closeModal" :cancelData="this.cancelParams"
            :reprintData="this.reprintParams" @disableOverlayClick="overlayClickEnabled = false"
            @enableOverlayClick="overlayClickEnabled = true">
        </CancelTefModal>
        <ProdBloqsContainer
            v-if="prodBlock"
            :taxValidationMode="taxValidationMode"
            :taxValidationData="taxValidationData"
            @toggleProdBolck="closeProdBlock">
        </ProdBloqsContainer>
        <ReprintModal v-if="showReprintModal" @closeReprintModal="closeReprintModal" @cancelTef="cancelTef"
            @reprintTef="reprintTef">
        </ReprintModal>
        <ConfirmConfigModal v-if="confirmConfig" ref="confirmConfigModal" :config="this.config" @openTaxModal="openTaxModalFromConfirmConfig"></ConfirmConfigModal>
        <SelectModal v-if="showSelectModal" :selectModalParams="selectModalParams" @selectSubisdiary="selectSubisdiary"
            @selectPos="selectPos"
            @close="closeSelectModal">
        </SelectModal>
        <FaceRegistrationModal v-if="showFaceRegistration" @closeFaceRegistration="closeFaceRegistrationModal">
        </FaceRegistrationModal>
        <FuncoesAdministrativasModal v-if="showFuncoesAdministrativasModal"
            @closeFuncoesAdministrativasModal="closeFuncoesAdministrativasModal"></FuncoesAdministrativasModal>
        <CollectDataModal v-if="showCollectDataModal" :params="collectDataModalParams"
            @closeCollectDataModal="closeCollectDataModal"></CollectDataModal>
        <PersonalCreditModal v-if="showPersonalCreditModal" @closePersonalCreditModal="closePersonalCreditModal">
        </PersonalCreditModal>
        <vue-touch-keyboard id="keyboard" :options="options" v-if="visible" :layout="layout" :cancel="hide"
            :accept="accept" :input="input" :next="next" />
    </div>
</template>

<script>
/* eslint-disable eqeqeq */
/* eslint-disable operator-linebreak */
import DefaultButton from '@/components/DefaultButton'
import BalancaModeConfig from '@/components/BalancaModeConfig/index'
import CancelTefModal from '@/components/CancelTefModal'
import Util from '@/assets/libs/util'
import PrinterController from '@/assets/controllers/PrinterController'
import LocaleController from '@/assets/controllers/LocaleController'
import AccessController from '@/assets/controllers/AccessController'
import requestModule from '@/assets/libs/requestModule'
import Vue from 'vue'
import VueTouchKeyboard from 'vue-touch-keyboard'
import style from 'vue-touch-keyboard/dist/vue-touch-keyboard.css'
import ProdBloqsContainer from '../components/ProdBloqsContainer.vue'
import ReprintModal from '@/components/ReprintModal'
import ConfirmConfigModal from '../components/ConfirmConfigModal.vue'
import SelectModal from '../components/SelectModal.vue'
import idxdDB from '@/assets/libs/IndexedDBController'
import UpdaterController from '../assets/controllers/UpdaterController'
import faceVideoComp from '../components/AIFaceVideoComponent.vue'
import CircleButton from '@/components/CircleButton'
import CameraController from '@/assets/controllers/CameraController'
import FaceRegistrationModal from '../components/FaceRegistrationModal.vue'
import FuncoesAdministrativasModal from '../components/FuncoesAdministrativasModal.vue'
import waitForDOMUpdate from '@/assets/libs/waitForDOMUpdate'
import CollectDataModal from '../components/CollectDataModal.vue'
import eventModule from '@/assets/libs/eventModule'
import PersonalCreditModal from '../components/PersonalCreditModal.vue'
Vue.use(VueTouchKeyboard)
Vue.use(style)

export default {
    name: 'Config',
    components: {
        DefaultButton,
        CancelTefModal,
        ReprintModal,
        BalancaModeConfig,
        'vue-touch-keyboard': VueTouchKeyboard.component,
        ProdBloqsContainer,
        ConfirmConfigModal,
        SelectModal,
        faceVideoComp,
        CircleButton,
        FaceRegistrationModal,
        FuncoesAdministrativasModal,
        CollectDataModal,
        PersonalCreditModal
    },
    data () {
        return {
            visible: false,
            layout: 'normal',
            options: {
                useKbEvents: false,
                preventClickEvent: false
            },
            input: null,
            overlayClickEnabled: true,
            controlsEnabled: true,
            errors: [],
            cdtiporecehomolog: '999',
            defaultImage: require('../../static/client/default.png'),
            balanca: require('../../static/icons/peso.png'),
            conect_white: require('../../static/icons/conect_white.svg'),
            print_white: require('../../static/icons/print_white.svg'),
            money_white: require('../../static/icons/money_white.svg'),
            close_white: require('../../static/icons/close_white.svg'),
            showCancelTefModal: false,
            cancelParams: null,
            showReprintModal: false,
            showOverlay: false,
            config: {
                urlOdhenInterface: '',
                urlIMGOdhenInterface: '',
                balancaport: '',
                sitefAddress: '',
                urlPerifericos: process.env.urlPerifericos || 'http://127.0.0.1:3000/',
                isEditMode: false,

                primary_color: `${getComputedStyle(document.body).getPropertyValue('--primary-color')}`.trim(),
                primary_light: `${getComputedStyle(document.body).getPropertyValue('--primary-light')}`.trim(),
                primary_dark: `${getComputedStyle(document.body).getPropertyValue('--primary-dark')}`.trim(),
                header_color: `${getComputedStyle(document.body).getPropertyValue('--header-color')}`.trim(),
                categorie_color: `${getComputedStyle(document.body).getPropertyValue('--categorie-color')}`.trim(),
                categorie_font_color: `${getComputedStyle(document.body).getPropertyValue('--categorie-font-color')}`.trim(),
                cart_color: `${getComputedStyle(document.body).getPropertyValue('--cart-color')}`.trim(),
                cart_font_color: `${getComputedStyle(document.body).getPropertyValue('--cart-font-color')}`.trim(),
                price_font_color: `${getComputedStyle(document.body).getPropertyValue('--price-font-color')}`.trim(),

                boldPrice: false,
                consumidorTipo: null,
                taas: [],
                comprimentoNSU: null,
                nomeDoDispositivo: process.env.nomeDoDispositivo,
                caixaCodigo: process.env.caixaCodigo,
                filialCodigo: process.env.filialCodigo,
                lojaCodigo: process.env.lojaCodigo,
                cardapioExpira: false,
                modotap: false,
                slimMode: false,
                enableProdBarCodeRead: false,
                acessibilidade: false,
                modobalanca: false,
                shouldAutoClose: false,
                homologPay: false,
                curtaa: {},

                images: {},
                metodosPagamento: [],
                tiposRecebimento: null,
                modeEntrega: [],
                modeEntregaDrive: [],
                tipoCaixa: 'venda',
                tipoTEF: null,
                modeloImpressora: this.isAndroid() ? 28 : 19,
                nomeImpressora: null,
                portaImpressora: 'USB',
                emissaoFiscal: null,
                produtoSemfoto: true,
                exibApartir: false,
                exibeContinuarComprando: false,
                removeConfirmImpressaoCupom: false,
                kioskPort: 0,
                usePager: false,
                useBarcode: false,
                allowMultipleAdd: true,
                enableSubgroups: true,
                permiteObsDigitada: false,
                itemsList: false,
                imprimeEspelho: true,
                // creditoPessoal: false,
                hideGroupOnMax: false,
                fixedServiceTax: false,
                automaticServiceTax: false,
                removTXServTap: false,
                iconesGrandes: false,
                showMinPriceDifference: false,
                useAlternativeLayout: true,
                utiliza_layout_gom: false,
                mainLanguage: [],
                idiomaAdic_pt_br: [],
                idiomaAdic_en: [],
                idiomaAdic_es: [],
                companyCodCRM: '',
                authCRM: '',
                apiUrlCRM: '',
                timeOut: 150,
                timeOutInModal: 30,
                enableJumpGroup: false,
                impFichas: false,
                curSubisdiary: {},
                infoConsTaa: false,
                lockKeyboardCons: false,
                addprodTAP: false,
                allowNotPrint: false,
                hidePrintButton: false,
                useBarcodeComand: false,
                useFaceRecognition: false, // utiliza o reconhecimento facial para login do consumidor TODO: adicionar esse parametro no retail
                transireToken: '',
                faceRecognitionApi: '',
                collectionCode: '',
                idSolDigCons: false,
                blockCnpjPdv: false,
                allowComplement: false,
                enableLoginInicio: false, // habilita o login no do consumidor no inicio da aplicação TODO: adicionar esse parametro no retail
                signalsDiscount: false, // sinaliza com um taxado o preço antigo ao lado do novo preço com desconto. TODO: adicionar esse parametro no retail
                ignoreQrCode: false, // ignora a leitura do QR Code no SK210 TODO: adicionar esse parametro no retail TODO: adicionar esse parametro no retail
                removeProdutoSugestaoAutomatico: false, // remove o produto sugestão automatico TODO: adicionar esse parametro no retail
                autoOpenCommand: false, // abre automaticamente o modal de adicionar um produto na comanda,
                clarityProjectId: '', // id do projeto do Clarity para analytics
                exibeSaldoConsumidorSemControle: true // exibe o saldo do consumidor que não controla saldo @TODO: adicionar esse parametro no retail
            },
            exportarConfig: null,
            importarConfig: null,
            imageList: Object.values(Util.getImageList()) || [],
            messages: {
                nomeDoDispositivo: this.getString('nome_dispositivo_obrigatorio'),
                urlOdhenInterface: this.getString('endereco_interface_obrigatorio'),
                // urlPerifericos: this.getString('endereco_perifericos_obrigatorio'),
                primary_color: function (self, key) {
                    if (!self.config.primary_color || !self.config.primary_light || !self.config.primary_dark) {
                        let errorMessage = this.getString('preenchimento_das_cores_obrigatorio')
                        self.setError(self, key, errorMessage)
                    } else if (Util.mode([self.config.primary_color, self.config.primary_light, self.config.primary_dark]) > 1) {
                        let errorMessage = this.getString('cores_nao_podem_ser_iguais')
                        self.setError(self, key, errorMessage)
                    }
                },
                consumidorTipo: function (self, key) {
                    if (!self.config.caixaCodigo || !self.config.lojaCodigo || !self.config.filialCodigo) {
                        let errorMessage = self.getString('parametros_aba_consumidor_faltando')
                        self.setError(self, key, errorMessage)
                    }
                },
                curtaa: this.getString('precisa_associar_totem_a_um_caixa')
            },
            exibeEndereco: false,
            exibeCores: false,
            exibeIdiomas: false,
            exibeConsumidor: false,
            exibeFunOperacionais: true,
            exibeSitef: false,
            exibeCappta: false,
            exibePagamento: false,
            exibeImpressora: false,
            exibeEmissaoFiscal: false,
            exibeProdutoSemfoto: false,
            exibeTEF: false,
            exibeModeEntrega: false,
            imageManage: false,
            exibelayoutConfig: false,
            exibeGeneralConfig: false,
            configManage: false,
            prodBlock: false,
            languages: [
                {
                    name: this.getString('portugues'),
                    code: 'pt-br'
                },
                {
                    name: this.getString('ingles'),
                    code: 'en'
                },
                {
                    name: this.getString('espanhol'),
                    code: 'es'
                }
            ],
            confirmConfig: false,
            operatorCode: '',
            isOracle: Util.isOracle(),
            showSelectModal: false,
            selectModalParams: {
                title: '',
                propertyToShow: [],
                propertyToSearch: [],
                selectModalData: [],
                selectAction: null,
                cancelAction: null
            },
            storedImages: [],
            gear: require('../../static/icons/gear.png'),
            isCameraConfigMenuOpen: false,
            cameras: [],
            selectedFaceCamera: null,
            selectedProductCamera: null,
            enableAllConfigs: false,
            isFaceRegisterOpen: false,
            showFaceRegistration: false,
            exibeModeBalanca: false,
            showModalBalanca: false,
            showFuncoesAdministrativasModal: false,
            showCollectDataModal: false,
            collectDataModalParams: {
                title: '',
                type: ''
            },
            showPersonalCreditModal: false,
            reprintParams: null,
            taxValidationMode: false,
            taxValidationData: null,
            taxValidationPendingCount: 0,
            taxValidationLoading: false
        }
    },
    mounted () {
        if (!(this.$route && this.$route.params && this.$route.params.firstLoad === true)) {
            this.$router.push({ name: 'WaitScreen' })
        } else {
            this.config = Util.getLocalVar('taaconfig') || this.config
            this.config.lojaCodigo = (this.config && this.config.lojaCodigo) || process.env.lojaCodigo
            this.config.useFaceRecognition = (this.config && this.config.useFaceRecognition) || false
            this.config.faceRecognitionApi = (this.config && this.config.faceRecognitionApi) || 'https://face-recognition-api-teste.teknisa.com/'
            // this.exportarConfig = this.prepareConfigJSON()
            if (!Util.isOracle()) {
                this.getServerStoredConfig()
            }
            this.getStoredImages()
        }
        this.operatorCode = AccessController.getOperator()
        this.checkFirstMainLanguage()
        this.checkAllConfigs(this.configs)
        this.loadCameras()
    },
    created () {
        eventModule.$on('showCollectDataModal', this.openCollectDataModal)
    },
    beforeDestroy () {
        eventModule.$off('showCollectDataModal', this.openCollectDataModal)
    },
    methods: {
        closeSelectModal: function () {
            this.showSelectModal = false
            this.showOverlay = false
        },
        isGertecSk210: function () {
            return Util.isGertecSk210()
        },
        hasPermission: function (permission) {
            return AccessController.getPermission(permission)
        },
        accept: function (text) {
            this.hide()
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target
                if (!this.visible) {
                    this.visible = true
                }
            }
        },
        hide: function () {
            this.visible = false
        },
        next: function () {
            let inputs = document.querySelectorAll('input')
            let found = false;
            [].forEach.call(inputs, (item, i) => {
                if (!found && item === this.input && i < inputs.length - 1) {
                    found = true
                    this.$nextTick(() => {
                        inputs[i + 1].focus()
                    })
                }
            })
            if (!found) {
                this.input.blur()
                this.hide()
            }
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        checkFirstMainLanguage: function () {
            let mainLanguageIsEmpty = this.config.mainLanguage && this.config.mainLanguage.length === 0
            if (mainLanguageIsEmpty) {
                this.config.mainLanguage.push(this.languages[0])
            }
        },
        changeMainLanguage: function (language, event) {
            this.config.mainLanguage = []
            if (event && event.srcElement.checked) {
                this.config.mainLanguage.push(language)
            }

            this.remarkLanguageIfEmpty(language, event)
            this.unmarkCorrespondentSecondaryLanguage(language.code)
        },
        remarkLanguageIfEmpty: function (language, event) {
            let mainLanguageIsEmpty = this.config.mainLanguage && this.config.mainLanguage.length === 0
            if (mainLanguageIsEmpty) {
                this.config.mainLanguage.push(language)
                event.srcElement.checked = true
            }
        },
        unmarkCorrespondentSecondaryLanguage: function (languageCode) {
            let secondaryPortugueseIsSelected = this.config.idiomaAdic_pt_br && this.config.idiomaAdic_pt_br.length > 0
            if (languageCode === 'pt-br' && secondaryPortugueseIsSelected) {
                this.config.idiomaAdic_pt_br = []
            }

            let secondaryEnglishIsSelected = this.config.idiomaAdic_pt_br && this.config.idiomaAdic_en.length > 0
            if (languageCode === 'en' && secondaryEnglishIsSelected) {
                this.config.idiomaAdic_en.length = []
            }

            let secondarySpanishIsSelected = this.config.idiomaAdic_pt_br && this.config.idiomaAdic_es.length > 0
            if (languageCode === 'es' && secondarySpanishIsSelected) {
                this.config.idiomaAdic_es.length = []
            }
        },
        checkSameLanguage: function (event) {
            let mainLanguageSelected = this.config.mainLanguage && this.config.mainLanguage[0] && this.config.mainLanguage[0].code
            let clickedSecondaryLanguage = event.srcElement.value
            if (mainLanguageSelected === clickedSecondaryLanguage) {
                event.srcElement.checked = false
            }
        },
        cancelTef: function (cancelParams = null) {
            if (cancelParams) {
                this.cancelParams = cancelParams
            }
            this.showCancelTefModal = true
        },
        reprintTef: async function (reprintParams = null) {
            if (reprintParams) {
                this.reprintParams = reprintParams
            }
            this.showCancelTefModal = true
            await waitForDOMUpdate.waitForDOMUpdate()
        },
        closeModal: function () {
            if (this.showSelectModal) {
                this.closeSelectModal()
                return
            }
            this.showCancelTefModal = false
            if (this.overlayClickEnabled) {
                this.showCancelTefModal = false
                this.prodBlock = false
                this.taxValidationMode = false
                this.taxValidationData = null
                this.showSelectModal = false
                this.showOverlay = false
                this.reprintParams = null
                this.cancelParams = null
            }
        },
        openReprintModal: function () {
            this.showReprintModal = true
        },
        closeReprintModal: function () {
            this.showReprintModal = false
        },
        getServerStoredConfig: function () {
            let self = this
            requestModule.postRequest('getBaseConfig', { type: 'basic' }).then(confData => {
                self.config.urlOdhenInterface = (process.env.urlOdhenInterface || (confData.enderecoInterface + '/'))
                self.config.urlIMGOdhenInterface = (process.env.urlIMGOdhenInterface || (confData.enderecoApache + '/'))
                self.config.lojaCodigo = self.config.lojaCodigo || (confData.lojaCodigo)
                self.config.filialCodigo = (process.env.filialCodigo || (confData.filialCodigo))
                self.cdtiporecehomolog = confData.cdtiporecehomolog || self.cdtiporecehomolog
                self.config.iconesGrandes = typeof (confData.iconesGrandes) === 'boolean' ? confData.iconesGrandes : false
                self.config.hotReload = confData.hotReload || self.hotReload

                if (!Util.getLocalVar('taaconfig')) {
                    Util.setLocalVar('taaconfig', self.config)
                }

                if (confData.img) {
                    let imagesCustom = Object.entries(confData.img).filter((pos) => pos[1]).map((pos) => pos)
                    imagesCustom.forEach(i => {
                        let url = Util.getBackAdress() + 'imagensCustomizaveis/'
                        this.config.images[i[0]] = url + i[1]
                    })
                }
            })
        },
        confirmImportConfig: async function () {
            Util.showConfirmationDialog(this.$modal, () => {
                this.getDefaultConfig()
            }, this.getString('deseja_importar_configuracoes_servidor'))
        },
        confirmExportConfig: function () {
            Util.showConfirmationDialog(this.$modal, () => {
                this.setDefaultConfig()
            }, this.getString('deseja_definir_configurações_atuais_padrão'))
        },
        confirmImportPosConfig: async function () {
            if (!this.config.curtaa || !this.config.curtaa.posCode) {
                return false
            }
            let storedConfigs = null
            if (!Util.isOracle()) {
                storedConfigs = await requestModule.postRequest('getPosConfig', { device: 'TAA', posCode: this.config.curtaa.posCode })
            }
            if (storedConfigs && !storedConfigs.error && this.enableAllConfigs) {
                Util.showConfirmationDialog(this.$modal, () => {
                    this.restorePosConfigs(storedConfigs)
                    this.setCaixaConf()
                }, `${this.getString('configuracoes_salvas_para_caixa')} ${this.config.curtaa.posCode}. ${this.getString('importar_configuracoes')}`, () => {
                    this.setCaixaConf()
                })
            } else {
                this.setCaixaConf()
            }
        },
        restorePosConfigs: function (configs) {
            let newConfig = Object.assign(this.config, configs)
            if (newConfig) {
                this.config = newConfig
                Util.showInfoModal(this.getString('configuracoes_importadas_sucesso'))
            } else {
                Util.showInfoModal(this.getString('falha_importar_config_caixa'))
            }
        },
        setDefaultConfig: async function () {
            const shareableConfigs = [
                'primary_color', 'primary_light', 'primary_dark', 'categorie_color', 'categorie_font_color', 'cart_color', 'cart_font_color', 'price_font_color', 'boldPrice',
                'consumidorTipo', 'comprimentoNSU', 'cardapioExpira', 'slimMode', 'acessibilidade', 'shouldAutoClose', 'images',
                'modeEntrega', 'modeEntregaDrive', 'produtoSemfoto', 'exibApartir', 'exibeContinuarComprando', 'removeConfirmImpressaoCupom', 'usePager', 'useBarcode', 'allowMultipleAdd',
                'enableSubgroups', 'permiteObsDigitada', 'itemsList', 'imprimeEspelho', 'hideGroupOnMax', 'fixedServiceTax',
                'showMinPriceDifference', 'mainLanguage', 'idiomaAdic_pt_br', 'idiomaAdic_en', 'idiomaAdic_es', 'useAlternativeLayout'
            ]
            let newConfig = {}
            shareableConfigs.forEach((e) => {
                newConfig[e] = this.config[e]
            })
            let result = await requestModule.postRequest('setDefaultConfig', { defaultConfigTaa: newConfig, type: 'TAA' })
            if (result && !result.error) {
                Util.showInfoModal(this.getString('configuracao_definida_padrao'))
            }
        },
        getDefaultConfig: async function () {
            let defaultConfigs = await requestModule.postRequest('getDefaultConfig', { type: 'TAA' })
            let defaultConfigTaa = defaultConfigs && defaultConfigs.defaultConfigTaa
            if (!defaultConfigTaa || defaultConfigs.error) {
                Util.showInfoModal(this.getString('falha_importar_config_padrao'))
                console.error(defaultConfigs.result.message)
                return false
            }
            Object.keys(defaultConfigTaa).forEach((e) => {
                this.config[e] = defaultConfigTaa[e]
            })
            Util.showInfoModal(this.getString('configuracao_padrao_importada'))
        },
        relatorioFechamentoDodia: async function () {
            let usesOpeningLock = this.config && this.config.curtaa && this.config.curtaa.usesOpeningLock
            if (usesOpeningLock === 'S') {
                this.confirmLastClosing()
            } else {
                await this.closeCashier()
            }
        },
        confirmLastClosing: function () {
            Util.showConfirmationDialog(this.$modal,
                async () => {
                    await this.closeCashier(true)
                }, this.getString('este_e_ultimo_fechamento_dia'),
                async () => {
                    await this.closeCashier()
                })
        },
        closeCashier: async function (lastClosing = false) {
            if (this.controlsEnabled) {
                this.controlsEnabled = false
                if (lastClosing) {
                    await PrinterController.relatorioFechamentoDodia(true, true)
                } else {
                    await PrinterController.relatorioFechamentoDodia()
                }
                this.controlsEnabled = true
            }
        },
        setError: function (self, key, msg) {
            self.errors.push(key)
            Util.showErrorNotification({ title: msg, text: null })
        },
        setConfigs: async function () {
            eventModule.$emit('stopVideo')
            this.isCameraConfigMenuOpen = false
            if (this.importarConfig) {
                this.config = JSON.parse(this.importarConfig)
            }
            let self = this
            self.errors = []
            Object.entries(this.messages).forEach(item => {
                let key = item[0]
                let msg = item[1]
                if (typeof msg === 'function') {
                    msg(self, key)
                } else if (!this.config[key]) {
                    Util.showErrorNotification({ title: msg, text: null })
                    this.errors.push(key)
                }
            })
            if (this.config.utiliza_layout_gom) {
                document.getElementsByTagName('body')[0].classList.add('gom-layout')
            }
            if (self.errors.length === 0) {
                this.confirmConfig = true
            }
        },
        setPosConfig: async function () {
            let configToSave = Util.deepCopy(this.config)

            // O configToSave.caixaCodigo não pode ser deletado, porque o backend vai usar para saber em que pasta
            // colocar esse arquivo de config
            delete configToSave.nomeDoDispositivo
            delete configToSave.storeCNPJ
            delete configToSave.enderecoIPTEF
            delete configToSave.codigoTerminalTEF
            delete configToSave.codLojaTEF
            delete configToSave.sendingCupEmail
            delete configToSave.curtaa
            delete configToSave.metodosPagamento
            delete configToSave.tiposRecebimento
            delete configToSave.taas

            await requestModule.postRequest('setPosConfig', { config: configToSave, device: 'TAA' })
        },
        setImage: async function (e, curImage) {
            let file = e.target.files[0]
            if (!file) {
                return false
            }
            let isVideo = this.isVideo(file.name)
            let allowVideo = (curImage === 'espera')
            if (!file) {
                return false
            }
            if (!this.config.caixaCodigo) {
                document.getElementById(curImage).value = null
                Util.showErrorNotification({ title: this.getString('precisa_associar_totem_a_um_caixa'), text: null })
                return false
            }
            if (isVideo && !allowVideo) {
                Util.showErrorNotification({ title: this.getString('video_nao_permitido'), text: null })
                return false
            }

            let curBase64 = await Util.toBase64(file)
            let db = await idxdDB.getImageDB()
            await idxdDB.deleteImagesSIFromDb()
            if (!this.storedImages) {
                this.storedImages = []
            }
            this.storedImages[e.target.id] = {
                image: curBase64,
                origin: 'local'
            }
            await idxdDB.addImagesSIToDb(this.storedImages, db).catch(e => {
                Util.showErrorNotification({ title: this.getString('falha ao atualizar imagem'), text: null })
            })
            this.$forceUpdate()
        },
        isVideo: function (fileName) {
            let videos = ['mp4', 'mkv', 'webm']
            if (!fileName) {
                return false
            }
            let ext = ''
            try {
                ext = fileName.split('/')[1].split(';').shift()
            } catch (e) {
                ext = ext = fileName.split('.').pop()
            }

            if (ext && videos.includes(ext)) {
                return true
            }
            return false
        },
        clearInput: async function (id) {
            this.storedImages[id] = null
            let db = await idxdDB.getImageDB()
            await idxdDB.deleteImagesSIFromDb()
            await idxdDB.addImagesSIToDb(this.storedImages, db).catch(e => {
                Util.showErrorNotification({ title: this.getString('falha ao atualizar imagem'), text: null })
            })
            document.getElementById(id).value = null
            this.$forceUpdate()
        },
        setNomeImpressora: function () {
            this.config.nomeImpressora = this.config.modeloImpressora
        },
        saveBalancaMode: function (weighed) {
            this.config.weighed = weighed
            this.showModalBalanca = false
        },
        setCaixaConf: function () {
            this.config.nomeDoDispositivo = this.config.curtaa.posName
            this.config.storeCNPJ = this.config.curtaa.storeCNPJ
            this.config.caixaCodigo = this.config.curtaa.posCode
            this.config.lojaCodigo = this.config.curtaa.storeCode
            this.config.enderecoIPTEF = this.config.curtaa.ipSiTef
            this.config.codigoTerminalTEF = this.config.curtaa.tefCode
            this.config.codLojaTEF = this.config.curtaa.storeTefCode
            this.config.sendingCupEmail = this.config.curtaa.sendingCupEmail === 'S'
            this.config.askPhoneNumber = this.config.curtaa.askPhoneNumber === 'S'
            Util.setLocalVar('taaconfig', this.config)
            this.checkAllConfigs()
        },
        prepareConfigJSON: function () {
            let configRaw = Util.deepCopy(Util.getLocalVar('taaconfig') || {})
            configRaw.nomeDoDispositivo = null
            configRaw.caixaCodigo = null
            configRaw.enderecoIPTEF = null
            configRaw.codigoTerminalTEF = null
            configRaw.codLojaTEF = null
            configRaw.curtaa = null
            configRaw.sendingCupEmail = false
            configRaw.taas = []
            return JSON.stringify(configRaw)
        },
        checkConectionStatus: async function (getTefData) {
            const method = Util.isOracle() ? 'get' : 'post'
            let resultOdhenInterface = await requestModule.postRequest('/', {}, method)
                .then((e) => {
                    if (!e || !e.data) {
                        return {
                            error: true,
                            message: this.getString('interface_nao_encontrada_404')
                        }
                    }
                    if (e.data && !e.data.connection) {
                        return {
                            error: true,
                            message: this.getString('interface_sem_conexao')
                        }
                    }
                    return {
                        error: false,
                        message: e.data.version
                    }
                })
                .catch((e) => {
                    return {
                        error: true,
                        message: this.getString('interface_nao_encontrada_404')
                    }
                })
            let message = resultOdhenInterface.message
            if (resultOdhenInterface.error) {
                Util.showInfoModal(message)
                this.exibeConsumidor = false
            } else if (!getTefData) {
                let infoMessage = this.getString('sucesso_interface') + resultOdhenInterface.message
                Util.showInfoModal(infoMessage)
            }
            if (!resultOdhenInterface.error && getTefData) {
                this.config.taas = await requestModule.postRequest('menu/getPosTefData', { storeCode: '', subsidiaryCode: this.config.filialCodigo, posCode: '' }).then(e => {
                    if (e.error) {
                        Util.showInfoModal(e.message)
                        return []
                    }
                    // return e.data.posTefData
                    return e.data.posTefData.filter(c => ['APC', 'TAA'].includes(c.posType))
                }).catch(e => {
                    Util.showInfoModal(e.message)
                })
                this.$forceUpdate()
            }
            return resultOdhenInterface
        },
        testPrinter: async function () {
            let testPrinterInfo = {
                printerType: this.config.modeloImpressora,
                kioskPort: this.config.kioskPort,
                port: this.config.portaImpressora
            }
            let testURLPerifericos = this.config.urlPerifericos
            let result = await PrinterController.testPrinter(testPrinterInfo, testURLPerifericos)
            if (result.error) {
                Util.showInfoModal(result.message)
            }
        },
        isAndroid: function () {
            return Util.isAndroidMode()
        },
        isNfseMode: function () {
            return Util.isNfseMode()
        },
        getUrlImage: function (id) {
            // config.images[imageReq.id]
            // if (Util.isOracle()) {
            return (this.storedImages && this.storedImages[id] && this.storedImages[id].image) || false
            // }
            // return this.config.images[id] ? Util.getUrlImage(this.config.images[id]) : false
        },
        toggleProdBolck: function () {
            this.prodBlock = !this.prodBlock
            if (!this.prodBlock) {
                this.taxValidationMode = false
                this.taxValidationData = null
            }
        },
        closeProdBlock: function () {
            this.prodBlock = false
            this.taxValidationMode = false
            this.taxValidationData = null
            this.taxValidationPendingCount = 0

            if (this.$refs.confirmConfigModal) {
                this.$refs.confirmConfigModal.$emit('taxModalClosed')
            }
        },
        openTaxModalFromConfirmConfig: function (taxData) {
            this.taxValidationData = taxData
            this.taxValidationMode = true
            this.prodBlock = true
            // Modal de informação caso tenha produtos com pendencias.
            Util.showInfoModal(this.getString('existem_produtos_com_inconsistencia_fiscal'))
        },
        openTaxValidation: async function () {
            if (this.taxValidationLoading) return
            this.taxValidationLoading = true

            const subsidiaryCode = (this.config.curSubisdiary && this.config.curSubisdiary.subsidiaryCode) || this.config.filialCodigo || ''
            const storeCode = (this.config.curtaa && this.config.curtaa.storeCode) || this.config.lojaCodigo || ''

            try {
                const result = await requestModule.postRequest('menu/taxValidation', {
                    subsidiaryCode,
                    storeCode
                })

                if (result && !result.error) {
                    const pending = (result.data && result.data.productsWithPending) || []
                    const noTax = (result.data && result.data.productsWithoutTax) || []

                    this.taxValidationData = result.data
                    this.taxValidationPendingCount = pending.length + noTax.length
                    this.taxValidationMode = true
                    this.prodBlock = true

                    if (pending.length === 0 && noTax.length === 0) {
                        Util.showInfoModal(this.getString('nenhum_produto_pendente'))
                        // não abre o modal
                        return
                    }
                } else {
                    const msg = (result && result.message) || this.getString('erro_validacao_fiscal')
                    Util.showInfoModal(msg)
                }
            } catch (e) {
                Util.showInfoModal(this.getString('erro_validacao_fiscal'))
            } finally {
                this.taxValidationLoading = false
            }
        },
        showSubisdiaryList: async function () {
            this.showOverlay = true
            let subsidiaryList = await requestModule.postRequest('login/getSubsidiaries', { 'operatorCode': this.operatorCode })
                .then(r => r)
                .catch(e => {
                    return {
                        error: true,
                        message: e
                    }
                })
            if (subsidiaryList && !subsidiaryList.error) {
                this.selectModalParams = {
                    title: 'Selecione a Filial',
                    propertyToShow: ['subsidiaryCode', 'subsidiaryName'],
                    propertyToSearch: ['subsidiaryCode', 'subsidiaryName'],
                    selectModalData: subsidiaryList.data,
                    selectAction: 'selectSubisdiary',
                    cancelAction: 'closeSelectModal'
                }
                this.showSelectModal = !this.showSelectModal
            } else {
                const error = subsidiaryList.error && subsidiaryList.message ? subsidiaryList.message : 'Não foi possivel obter a lista de filiais'
                Util.showInfoModal(error)
            }
        },
        selectSubisdiary: function (item) {
            this.showSelectModal = false
            this.showOverlay = false
            this.config.curSubisdiary = item
            this.config.taas = item.pos
            this.config.caixaCodigo = null
            this.config.nomeDoDispositivo = null
        },
        showPosList: async function () {
            if (this.config.taas) {
                this.selectModalParams = {
                    title: 'Selecione o Caixa',
                    propertyToShow: ['posCode', 'posName'],
                    propertyToSearch: ['posCode', 'posName'],
                    selectModalData: this.config.taas,
                    selectAction: 'selectPos',
                    cancelAction: 'closeSelectModal'
                }
                this.showSelectModal = true
            }
        },
        selectPos: function (item) {
            this.showSelectModal = false
            this.config.curtaa = item
            this.config.nomeDoDispositivo = item.posName
            this.config.caixaCodigo = item.posCode
            this.config.filialCodigo = this.config.curSubisdiary.subsidiaryCode
            this.config.lojaCodigo = item.storeCode
            Util.setLocalVar('taaconfig', this.config)
        },
        getStoredImages: async function () {
            let db = await idxdDB.getImageDB()
            let imagesOBJ = await idxdDB.getImagesSIsFromDb(db)
            if (imagesOBJ) {
                this.storedImages = imagesOBJ
            }
        },
        toggleCameraConfigMenu: function () {
            this.isCameraConfigMenuOpen = !this.isCameraConfigMenuOpen
            this.loadCameras()
        },
        closeCameraConfigMenu: function () {
            this.isCameraConfigMenuOpen = false
        },
        loadCameras: async function () {
            if (Util.isAndroidMode()) {
                return false
            }
            this.cameras = await CameraController.getAllCameraDevices()
            // Carregar configurações atuais se existirem
            this.selectedFaceCamera = await CameraController.getCameraDeviceForScreen('face')
            this.selectedProductCamera = await CameraController.getCameraDeviceForScreen('product')
        },
        applyCameraSettings: function () {
            CameraController.setCameraDeviceForScreen('face', this.selectedFaceCamera)
            // CameraController.setCameraDeviceForScreen('product', this.selectedProductCamera)
            eventModule.$emit('restartVideoComponent')
            this.closeCameraConfigMenu()
            // this.$router.go()
        },
        checkAllConfigs: async function () {
            this.showOverlay = true
            this.overlayClickEnabled = false

            if (this.config.filialCodigo && this.config.lojaCodigo && this.config.caixaCodigo && process.env.NODE_ENV === 'production') {
                let newDefaultParams = await UpdaterController.getNewDefaultParams(this.configs)
                let key = this.config.filialCodigo + this.config.lojaCodigo + this.config.caixaCodigo
                newDefaultParams = (newDefaultParams && newDefaultParams.posConfigs && newDefaultParams.posConfigs[key]) || (newDefaultParams && newDefaultParams.generalConfigs)
                let configs = (newDefaultParams && newDefaultParams.configInfo) || null
                let colors = (newDefaultParams && newDefaultParams.coresInfo) || null
                const hasNewConfigsRetail = UpdaterController.checkHasConfigsRetail(configs, null)
                const hasNewColorsRetail = UpdaterController.checkHasConfigsRetail(null, colors)

                if (!configs || (!hasNewConfigsRetail && !hasNewColorsRetail)) {
                    this.enableAllConfigs = true
                } else {
                    this.config.modobalanca = configs && configs.modobalanca
                    this.$forceUpdate()
                }
            } else {
                this.enableAllConfigs = process.env.NODE_ENV !== 'production'
            }
            // é chamada também no mounted
            if (this.config.lojaCodigo && this.config.filialCodigo && this.config.caixaCodigo) {
                const posTefData = await requestModule.postRequest('menu/getPosTefData', { storeCode: this.config.lojaCodigo, subsidiaryCode: this.config.filialCodigo, posCode: this.config.caixaCodigo }).then(e => {
                    if (e.error) {
                        return []
                    }
                    this.config.taas = e.data.posTefData.filter(c => ['APC', 'TAA'].includes(c.posType))
                    return e.data.posTefData.filter(c => this.config.caixaCodigo === c.posCode)
                }).catch(e => {
                    return false
                })

                if (posTefData && posTefData[0]) {
                    this.config.curtaa = posTefData && posTefData[0]
                    this.uptadePrinter()
                }
            }
            this.selectedFaceCamera = await CameraController.getCameraDeviceForScreen('face')
            this.selectedProductCamera = await CameraController.getCameraDeviceForScreen('product')
            this.showOverlay = false
            this.overlayClickEnabled = false
        },
        disableGomLayout: function (item) {
            if (item && this.config.utiliza_layout_gom) this.config.utiliza_layout_gom = false
        },
        openFaceRegistrationModal: function () {
            this.showFaceRegistration = true
        },
        closeFaceRegistrationModal: function () {
            this.showFaceRegistration = false
        },

        uptadePrinter: function () {
            if (this.config.curtaa && this.config.curtaa.printerConfigs && (!this.isGertecSk210() && !this.isTectoy())) {
                let printerConfigs = this.config.curtaa.printerConfigs
                this.config.modeloImpressora = (printerConfigs && printerConfigs.ModelCode) || ''
                this.config.nomeImpressora = (printerConfigs && printerConfigs.printerName) || ''
                this.config.portaImpressora = (printerConfigs && printerConfigs.port) || (printerConfigs && printerConfigs.ip) || ''
            }
        },
        getManufacturerAndroid: function () {
            return Util.getManufacturerAndroid()
        },
        isTectoy: function () {
            return Util.isTectoy()
        },
        iniciaFuncoesAdministrativas: function () {
            this.showFuncoesAdministrativasModal = true
            this.showOverlay = true
            this.overlayClickEnabled = false
        },
        closeFuncoesAdministrativasModal: async function () {
            this.showFuncoesAdministrativasModal = false
            this.showOverlay = false
        },
        openCollectDataModal: function (data) {
            this.collectDataModalParams = data
            this.showCollectDataModal = true
        },
        closeCollectDataModal: function () {
            this.showCollectDataModal = false
            this.showOverlay = false
        },
        openPersonalCreditModal: function () {
            this.showPersonalCreditModal = true
        },
        closePersonalCreditModal: function () {
            this.showPersonalCreditModal = false
            this.showOverlay = false
        },
        isTransire: function () {
            return Util.isTransire()
        },
        registerTransireToken: async function () {
            let params = {
                type: 'INIT',
                token: this.config.transireToken
            }
            console.log('registerTransireToken')
            await window.TransireIntegration.init(JSON.stringify(params))
        }
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.hidden-group {
    overflow: hidden;
    height: 0;
}

h1,
h2 {
    color: @primary-color;
}

.config {
    font-size: 2rem;

    &:before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: lightgray;
    }

    .header {
        background: @primary-color;
        position: relative;
        height: 180px;

        h1 {
            font-size: 4rem;
            color: white;
            left: 50%;
            top: 50%;
            display: inline-block;
            transform: translate(-50%, -50%);
            position: relative;
        }
    }

    .apply-btn-container {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 20px 0;

        .apply-btn {
            display: inherit;
            justify-content: center;
            align-items: center;
            background-color: @primary-color;
            border: solid 1px @primary-color;
            height: 40px;
            color: @white;
            width: 50%;
        }
    }

    .video {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .config-container {
        padding: 0 15px 15px 15px;
        overflow: auto;
        position: relative;
        height: calc(100vh - 392px);

        .config-group {
            margin: 15px 0 0 0;
            transition: all .2s ease-in-out;

            h2 {
                position: relative;
                display: block;
                padding: 10px 15px;
                color: white;
                background: @primary-color;

                .icon {
                    position: relative;
                    display: inline-block;
                    vertical-align: middle;
                    transform: rotate(180deg);
                    transition: all .2s ease-in-out;
                }

                .title {
                    display: inline-block;
                    vertical-align: middle;
                    margin-left: 30px;
                }
            }

            .cofig-item-container {
                .hidden-group;
                background: rgba(211, 211, 211, 0.5);
                border-bottom-left-radius: 5px;
                border-bottom-right-radius: 5px;

                .cofig-item {
                    display: grid;
                    grid-template-columns: calc(40% - 7.5px) calc(60% - 7.5px);
                    grid-column-gap: 15px;
                    margin: 0 0 15px 0;
                    position: relative;

                    &.inline-item {
                        grid-template-columns: calc(30% - 7.5px) auto auto;
                    }

                    .test-printer-container {
                        padding-top: 16px;
                        display: flex;
                        justify-content: center;

                        .test-printer-box {
                            width: 65%;
                            padding: 12px 24px;
                            display: flex;
                            align-items: center;
                            color: @white;
                            background-color: @primary-dark;
                            border-radius: 5px;

                            &--tax {
                                background-color: @primary-dark;
                                position: relative;
                                .tax-pending-badge {
                                    position: absolute;
                                    top: -8px;
                                    right: -8px;
                                    min-width: 22px;
                                    height: 22px;
                                    padding: 0 5px;
                                    border-radius: 11px;
                                    background: #e74c3c;
                                    color: white;
                                    font-size: 1.2rem;
                                    font-weight: bold;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                }
                            }

                            .x-image {
                                width: 30px;
                                padding-left: 10px;
                            }

                            img {
                                padding-right: 24px;
                                width: 3.5rem;
                            }
                        }
                    }

                    .operational-functions-container {
                        padding-top: 16px;
                        display: flex;
                        justify-content: center;

                        .operational-functions-box {
                            padding: 12px 24px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: @white;
                            background-color: @primary-dark;
                            border-radius: 5px;
                            width: 100%;

                            img {
                                padding-right: 24px;
                                width: 3.5rem;
                            }
                        }
                    }

                    .subsidiary-Input {
                        vertical-align: middle;
                        font-size: 2rem;
                        padding: 5px 15px;
                        border: none;
                        outline: none;
                        color: black;
                        background-color: @white
                    }

                    label {
                        position: relative;
                        display: inline-block;
                        top: 50%;
                        transform: translate(0, -50%);
                        margin: 0;
                    }

                    .balanca-placer {
                        position: absolute;
                        left: 50%;
                        top: 0;
                        bottom: 0;
                        right: 0;
                    }

                    input {
                        vertical-align: middle;
                        font-size: 2rem;
                        padding: 5px 15px;
                        border: none;
                        outline: none;

                        &[type=text] {
                            color: black;
                        }

                        &[type=color] {
                            border: none;
                            height: 100px;
                            width: 100%;
                            box-sizing: inherit;
                            appearance: initial;
                            padding: 0;
                        }
                    }

                    .img-container {
                        position: relative;

                        img {
                            display: block;
                            margin: auto;
                            max-height: 180px;
                            max-width: 300px;
                        }

                        iframe {
                            display: block;
                            margin: auto;
                            height: 180px;
                            max-width: 300px;
                            border: none;
                        }

                        video {
                            display: block;
                            margin: auto;
                            height: 180px;
                            border: none;
                        }

                        input {
                            padding: 0;
                            opacity: 0;
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            bottom: 0;
                        }

                        .clear-input {
                            position: absolute;
                            z-index: 1;
                            right: 10%;
                            top: 50%;
                            transform: translate(0, -50%);
                            color: red;
                            font-weight: bold;
                        }
                    }
                }
            }

            .cofig-item-container {
                &.checkbox {
                    display: grid;
                    grid-template-columns: auto auto auto;

                    &.radiobox {
                        grid-template-columns: 15% 30% 55%;

                        .semi {
                            grid-template-columns: 50% 50%;
                            border-left: solid 1px;
                            padding-left: 15px;
                        }
                    }
                }
            }

            &.open {
                h2 .icon {
                    transform: rotate(270deg);
                }

                .cofig-item-container {
                    padding: 30px 50px 15px 50px;
                    overflow: inherit;
                    height: auto;

                    &.fluid {
                        padding-top: 0;
                    }
                }
            }

            &:first-of-type {
                margin-top: 30px;
            }
        }

        .config-group-disabled {
            pointer-events: none;

            h2 {
                background-color: #ccc;
            }
        }

        .button-default {
            position: fixed;
            bottom: 80px;
            left: 0;
            right: 0;
            display: inline-block;
            margin: auto;
            width: 98%;
        }

        &.keyboard-open {
            height: calc(100vh - 760px);
        }
    }
}

.troca {
    position: absolute;
    margin-left: -9999px;
    visibility: hidden;
}

.troca+label {
    display: block;
    position: relative;
    cursor: pointer;
    outline: none;
    user-select: none;
}

.opcaoComSwitch+label {
    margin-top: -25px;
    padding: 2px;
    width: 50px;
    height: 25px;
    background-color: #dddddd;
    border-radius: 20px;
}

.opcaoComSwitch+label:before,
.opcaoComSwitch+label:after {
    display: block;
    position: absolute;
    top: 1px;
    left: 1px;
    bottom: 1px;
    content: '';
}

.opcaoComSwitch+label:before {
    right: 1px;
    background-color: @primary-light;
    border-radius: 20px;
    transition: all 0.4s;
}

.opcaoComSwitch+label:after {
    width: 25px;
    background-color: #ccc;
    border-radius: 50%;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    transition: all 0.4s;
}

.opcaoComSwitch:checked+label:before {
    background: @primary-color;
}

.opcaoComSwitch:checked+label:after {
    transform: translateX(35px);
    background-color: green;
}

.semFoto {
    margin-left: 15px;
    margin-top: 10px;
    width: 50%;
    padding: 8px;
}

select {
    font-size: 2rem;
    padding: 5px 15px;
}

.overlay {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 19;
}

.config-radios {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    background: rgba(211, 211, 211, 0.5);
    padding: 15px 0 35px 40px;

    .option {
        display: flex;
        margin-top: 15px;
        padding-left: 30px;
        align-items: center;
        grid-template-columns: 20% 80%;
    }
}

#keyboard {
    .keyboard;
    position: fixed;
    bottom: 60px;
}

@media (max-width: 698px) {

    // Gertec SK210
    .config {
        font-size: 15px;

        .header {
            height: 50px;

            h1 {
                font-size: 30px;
            }
        }

        .config-container {
            height: calc(100vh - 165px);

            .config-group {
                .cofig-item-container {
                    .cofig-item {
                        .test-printer-container {
                            padding-top: 0;

                            .test-printer-box {
                                .x-image {
                                    width: 20px;
                                    padding-left: 5px;
                                }

                                img {
                                    width: 30px;
                                }
                            }
                        }

                        input {
                            font-size: 20px;
                            height: 30px;
                            margin: auto 0;
                        }

                        .img-container {
                            img {
                                max-height: 90px;
                            }

                            iframe {
                                height: 90px;
                            }

                            video {
                                height: 90px;
                            }
                        }

                        .subsidiary-Input {
                            vertical-align: middle;
                            font-size: 1rem;
                            padding: 5px 15px;
                            border: none;
                            outline: none;
                            color: black;
                            background-color: @white
                        }
                    }
                }

                &.open {
                    .cofig-item-container {
                        &.checkbox {
                            padding: 15px 50px 0 20px;
                        }
                    }
                }
            }

            &.keyboard-open {
                height: calc(100vh - 400px);
            }

            .button-default {
                bottom: 40px;
            }
        }

        .opcaoComSwitch+label {
            width: 30px;
            height: 15px;
        }

        .opcaoComSwitch+label:after {
            width: 15px;
        }

        .opcaoComSwitch:checked+label:after {
            transform: translateX(20px);
        }
    }

    select {
        font-size: 20px;
        height: 40px;
    }

    .config-radios {
        grid-template-columns: 1fr 1fr 1fr;
        padding: 0 0 15px 0;

        .option {
            padding-left: 20px;

            .language-label {
                margin-left: -15px;
            }
        }
    }
    #keyboard {
        // .keyboard;
        position: fixed;
        bottom: 30px;
        // max-width: 760px;
        width: 95%;
        font-size: 18px;
        padding: 10px;
    }

    // .block-prods-container {
    //     .title-box h2{
    //         font-size: 20px;
    //     }
    //     #keyboard[data-v-60a7da3e] {
    //         position: fixed;
    //         left: 0;
    //         right: 0;
    //         bottom: 0px;
    //         z-index: 1000;
    //         width: 100%;
    //         max-width: 880px;
    //         margin: 0 auto;
    //         // padding: 1em;
    //         background-color: var(--white);
    //         -webkit-box-shadow: 0px -3px 5px rgb(0 0 0%);
    //         box-shadow: 0px -3px 5px rgb(0 0 0%);
    //         border-radius: 10px;
    //         /* font-size: 1.7rem; */
    //     }
    // }
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    .config {
        font-size: 1.5rem;

        .header {
            height: 130px;

            h1 {
                font-size: 3.2rem;
            }
        }

        .config-container {
            height: calc(100vh - 300px);

            .config-group {
                .cofig-item-container {
                    .hidden-group;

                    .cofig-item {
                        grid-template-columns: 45% 55%;

                        .test-printer-container {
                            padding-top: 12px;

                            .test-printer-box {
                                padding: 8px 18px;

                                img {
                                    padding-right: 18px;
                                    width: 3rem;
                                }
                            }
                        }

                        input {
                            font-size: 1.7rem;

                            &[type=color] {
                                height: 75px;
                            }
                        }

                        .subsidiary-Input {
                            vertical-align: middle;
                            font-size: 1.2rem;
                            padding: 5px 15px;
                            border: none;
                            outline: none;
                            color: black;
                            background-color: @white
                        }
                    }

                    .config-Item-side-side {
                        padding-top: 12px;
                        grid-template-columns: 45% 55%;
                    }
                }

                &.open {
                    .cofig-item-container {
                        padding: 30px 30px 15px 30px;
                    }
                }
            }

            &.keyboard-open {
                height: calc(100vh - 560px);
            }

            .button-default {
                position: fixed;
                bottom: 70px;
                left: 0;
                right: 0;
                display: inline-block;
                margin: auto;
                width: 98%;
            }
        }
    }

    select {
        font-size: 1.7rem;
    }

    .label-mod-entrega {
        margin-left: -30px;
    }

    .label-mod-entrega-last {
        margin-left: -20px;
    }

    #keyboard {
        .keyboard;
        position: fixed;
        bottom: 60px;
        // max-width: 760px;
        width: 95%;
        font-size: 20px;
    }
}

@media (orientation: landscape) {

    //@tablet
    .config {
        font-size: 1.3rem;

        .header {
            height: 90px;

            h1 {
                font-size: 2.2rem;
            }
        }

        .config-container {
            height: calc(100vh - 230px);
            padding: 0 15px 15px 15px;

            .config-group {
                .cofig-item-container {
                    .hidden-group;

                    .cofig-item {
                        grid-template-columns: 45% 55%;

                        .test-printer-container {
                            padding-top: 12px;

                            .test-printer-box {
                                padding: 8px 18px;
                                width: 45%;

                                img {
                                    padding-right: 18px;
                                    width: 3rem;
                                }
                            }
                        }

                        input {
                            font-size: 1.3rem;

                            &[type=color] {
                                height: 55px;
                            }
                        }

                        .subsidiary-Input {
                            vertical-align: middle;
                            font-size: 1.2rem;
                            padding: 5px 15px;
                            border: none;
                            outline: none;
                            color: black;
                            background-color: @white
                        }
                    }

                    .config-Item-side-side {
                        padding-top: 12px;
                        grid-template-columns: 45% 55%;
                    }
                }

                &.open {
                    .cofig-item-container {
                        padding: 30px 30px 15px 30px;
                    }
                }
            }

            &.keyboard-open {
                height: calc(100vh - 560px);
            }

            .button-default {
                position: fixed;
                bottom: 45px;
                left: 0;
                right: 0;
                display: inline-block;
                margin: auto;
                width: 98%;
            }
        }
    }

    select {
        font-size: 1.7rem;
    }

    .label-mod-entrega {
        margin-left: -30px;
    }

    .label-mod-entrega-last {
        margin-left: -20px;
    }

    #keyboard {
        .keyboard;
        position: fixed;
        bottom: 30px;
        // max-width: 760px;
        width: 96%;
        font-size: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Config.vue